import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { Icon } from '../components/Icon.tsx';
import { dv } from '../i18n/dv.ts';

const TABS = [
  { to: '/statistics/submissions', label: dv.stats.submissionsTab, icon: 'bar_chart' },
  { to: '/statistics/attendance', label: dv.stats.attendanceTab, icon: 'group' },
  { to: '/statistics/summary', label: dv.stats.summaryTab, icon: 'description' },
  { to: '/statistics/compliance', label: dv.stats.complianceTab, icon: 'fact_check' },
] as const;

// Statistics shell — a Material 3 tab bar sits under the page title and routes
// between the four statistics views via the nested <Outlet>.
export function Statistics(): JSX.Element {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="page space-y-6 lg:space-y-8">
      <header>
        <h1 className="text-3xl font-bold tracking-tight">{dv.stats.title}</h1>
      </header>
      {/* M3 tab bar — a scrollable strip of segments with a leading icon; the
          active tab is filled with secondary-container. */}
      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => {
          const active = pathname === t.to;
          return (
            <Link
              key={t.to}
              to={t.to}
              className={`inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active
                  ? 'bg-[hsl(var(--secondary-container))] text-[hsl(var(--on-secondary-container))]'
                  : 'text-muted-foreground hover:bg-black/[0.04] hover:text-foreground dark:hover:bg-white/[0.06]'
              }`}
            >
              <Icon name={t.icon} size={18} fill={active} />
              {t.label}
            </Link>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
